import { createBrowserRouter, Navigate, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';

// project imports
import MainRoutes from './MainRoutes';
import LoginRoutes from './LoginRoutes';
import ProtectedRoutes from './ProtectedRoutes';
import AccountRoutes from './AccountRoutes';
import UserRoutes from './UserRoutes';
import NotFound from 'pages/extra-pages/NotFound';
import RootLayout from '../layout/RootLayout';
import { APP_DEFAULT_PATH } from 'config';

// DeveloperProtectedRoutes: Only allows access if user is a developer
import { useAuth } from '../contexts/AuthContext';
function DeveloperProtectedRoutes({ children }) {
  const { user } = useAuth();
  const location = useLocation();
  if (!user || (user.role !== 'developer' && user.role !== 'super-admin')) {
    // Redirect non-developers and non-super-admins to home or not authorized page
    return <Navigate to={APP_DEFAULT_PATH} state={{ from: location }} replace />;
  }
  return children;
}

DeveloperProtectedRoutes.propTypes = {
  children: PropTypes.node.isRequired
};

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      {
        index: true,
        element: <Navigate to={APP_DEFAULT_PATH} replace />
      },
      LoginRoutes,
      {
        ...MainRoutes,
        element: <ProtectedRoutes>{MainRoutes.element}</ProtectedRoutes>
      },
      {
        ...AccountRoutes,
        element: <ProtectedRoutes>{AccountRoutes.element}</ProtectedRoutes>
      },
      // Developer and super-admin roles can access user management routes
      {
        ...UserRoutes,
        element: (
          <ProtectedRoutes>
            <DeveloperProtectedRoutes>{UserRoutes.element}</DeveloperProtectedRoutes>
          </ProtectedRoutes>
        )
      },
      {
        path: '*',
        element: <NotFound /> // 404 page
      }
    ]
  }
]);

export default router;
